module.exports = __webpack_public_path__ + "static/graduate-9318827f5daa08cd82842471d56cc197.jpg";